import { AvantioAccommodation } from "../../../../models/integrations/avantio.models";
import { AvantioAccommodationDTO } from "../dtos";

export const mapAvantioAccommodationsDTOToAvantioAccommodations = (
  dto: AvantioAccommodationDTO[]
): AvantioAccommodation[] =>
  dto.map((accommodation) => ({
    id: accommodation.id,
    name: accommodation.name,
    type: accommodation.type,
    status: accommodation.status,
  }));
